import React from 'react';
import { Title } from 'react-admin';
import InvitationLink from './InvitationLink';

/**
 * 邀请链接页面组件
 * 用于在react-admin中作为资源页面显示
 */
const InvitationLinkPage = () => {
    return (
        <div>
            <Title title="Invitation Link" />
            <InvitationLink />
        </div>
    );
};

export default InvitationLinkPage;